module.exports = __webpack_public_path__ + "static/img/Nome.80c6a088.png";